export default __webpack_public_path__ + "93fdeba37e44ddfd45cc05fa16ab2242.png";